// extracted by mini-css-extract-plugin
export default {"navbarMenus":"ListMenu_navbarMenus__GR27D"};